import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-button-skeleton',
  templateUrl: './payment-panel-button-skeleton.component.html',
})
export class PaymentPanelButtonSkeletonComponent {}
